package redmcrosco.alex.farmatch.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import farmatch.composeapp.generated.resources.*
import org.jetbrains.compose.resources.stringResource
import redmcrosco.alex.farmatch.models.UserRole

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SupportoScreen(
    viewModel: AuthViewModel,
    onBack: () -> Unit
) {
    val uriHandler = LocalUriHandler.current
    val userEmail = viewModel.currentUserEmail ?: stringResource(Res.string.user_not_logged_in)
    val userId = (viewModel.currentUserFarmacia?.userId ?: viewModel.currentUserFarmacista?.userId) ?: "N/A"
    val userRole = viewModel.currentUserRole?.name ?: "N/A"
    
    val themeColorHex = viewModel.selectedThemeColor.hex.removePrefix("0x").toLong(16)
    val themeColor = Color(themeColorHex)
    
    var messaggio by remember { mutableStateOf("") }

    val feedbackOpt = stringResource(Res.string.support_feedback_option)
    val technicalOpt = stringResource(Res.string.support_technical_option)
    val reportOpt = stringResource(Res.string.support_report_option)
    val otherOpt = stringResource(Res.string.support_other_option)

    var tipoSegnalazione by remember { mutableStateOf(feedbackOpt) }
    val opzioni = listOf(feedbackOpt, technicalOpt, reportOpt, otherOpt)
    var expanded by remember { mutableStateOf(false) }

    val subjectTemplate = stringResource(Res.string.support_email_subject, tipoSegnalazione, userEmail)
    val bodyTemplate = stringResource(Res.string.support_email_body, messaggio, userId, userEmail, userRole)

    Scaffold(
        containerColor = Color.Transparent,
        topBar = {
            TopAppBar(
                colors = TopAppBarDefaults.topAppBarColors(containerColor = Color.Transparent),
                title = { Text("") },
                navigationIcon = {
                    IconButton(onClick = onBack) {
                        Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = stringResource(Res.string.back_nav))
                    }
                }
            )
        }
    ) { padding ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .verticalScroll(rememberScrollState())
                .padding(horizontal = 16.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // --- DASHBOARD STILE APP ---
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(
                    containerColor = if (themeColor == Color.White) Color.White.copy(alpha = 0.1f) else themeColor.copy(alpha = 0.08f)
                ),
                shape = RoundedCornerShape(16.dp),
                border = androidx.compose.foundation.BorderStroke(
                    width = 0.5.dp,
                    color = if (themeColor == Color.White) Color(0xFFC0C0C0) else themeColor.copy(alpha = 0.2f)
                ),
                elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
            ) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Text(
                        text = stringResource(Res.string.support_title),
                        style = MaterialTheme.typography.headlineMedium.copy(fontWeight = FontWeight.Bold),
                        color = when {
                            themeColor == Color.White -> Color.Black
                            themeColor == Color(0xFF2196F3) -> Color(0xFF0D47A1)
                            else -> themeColor
                        }
                    )
                }
            }

            Spacer(modifier = Modifier.height(24.dp))

            Card(
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(16.dp),
                colors = CardDefaults.cardColors(containerColor = Color.White),
                elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
            ) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Text(
                        stringResource(Res.string.how_can_we_help),
                        style = MaterialTheme.typography.titleLarge,
                        color = themeColor,
                        fontWeight = FontWeight.Bold
                    )
                    Spacer(modifier = Modifier.height(8.dp))
                    Text(
                        stringResource(Res.string.support_intro),
                        style = MaterialTheme.typography.bodyMedium,
                        color = Color.Gray
                    )

                    Spacer(modifier = Modifier.height(24.dp))

                    // Tipo Segnalazione
                    Box(modifier = Modifier.fillMaxWidth()) {
                        OutlinedCard(
                            onClick = { expanded = true },
                            modifier = Modifier.fillMaxWidth(),
                            shape = RoundedCornerShape(12.dp)
                        ) {
                            Row(
                                modifier = Modifier.padding(16.dp).fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(stringResource(Res.string.support_type_label, tipoSegnalazione))
                                Icon(AppIcons.ArrowDropDown, contentDescription = null, tint = themeColor)
                            }
                        }
                        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
                            opzioni.forEach { opzione ->
                                DropdownMenuItem(
                                    text = { Text(opzione) },
                                    onClick = {
                                        tipoSegnalazione = opzione
                                        expanded = false
                                    }
                                )
                            }
                        }
                    }

                    Spacer(modifier = Modifier.height(16.dp))

                    // Messaggio
                    OutlinedTextField(
                        value = messaggio,
                        onValueChange = { messaggio = it },
                        label = { Text(stringResource(Res.string.support_message_label)) },
                        modifier = Modifier.fillMaxWidth().height(150.dp),
                        placeholder = { Text(stringResource(Res.string.support_message_placeholder)) },
                        shape = RoundedCornerShape(12.dp)
                    )

                    Spacer(modifier = Modifier.height(24.dp))

                    Button(
                        onClick = {
                            val mailto = "mailto:farmatch00@gmail.com?subject=${subjectTemplate.encodeURL()}&body=${bodyTemplate.encodeURL()}"
                            uriHandler.openUri(mailto)
                        },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = messaggio.isNotBlank(),
                        shape = RoundedCornerShape(12.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = themeColor)
                    ) {
                        Text(stringResource(Res.string.send_report_button))
                    }
                }
            }
            
            Spacer(modifier = Modifier.height(24.dp))
            
            Text(
                stringResource(Res.string.support_alternative),
                style = MaterialTheme.typography.labelSmall,
                color = Color.Gray
            )
            Text(
                "farmatch00@gmail.com",
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = FontWeight.Bold,
                color = themeColor
            )
            Spacer(modifier = Modifier.height(32.dp))
        }
    }
}

// Helper semplice per codificare l'URL
fun String.encodeURL(): String {
    return this.replace(" ", "%20")
        .replace("\n", "%0A")
        .replace("[", "%5B")
        .replace("]", "%5D")
}
